module.exports = __webpack_public_path__ + "img/goldregen-2020-123.773a91b5.jpg";